module.exports = __webpack_public_path__ + "static/media/ic_email.7c4aa415.svg";